import React, {useEffect, useState} from "../../_snowpack/pkg/react.js";
import "./App.css";
import * as swm from "../../_snowpack/pkg/swm-client-lib.js";
const demoHandle = "RXhhbXBsZSBoYW5kbGUK";
const demoEhrOrigin = "https://barabo.github.io";
const defaultOrigin = localStorage.getItem("app/ehrOrigin") || demoEhrOrigin;
const defaultHandle = localStorage.getItem("app/messageHandle") || demoHandle;
const mockClient = {
  tokenResponse: {
    access_token: "VGhpcyBpcyBhbiBleGFtcGxlIGFjY2Vzc190b2tlbiEK",
    token_type: "bearer",
    expires_in: 3600,
    scope: "patient/Patient.read messaging/ui.launchActivity",
    smart_web_messaging_origin: defaultOrigin,
    smart_web_messaging_handle: defaultHandle,
    state: "c3RhdGUgZXhhbXBsZSEK"
  }
};
function App() {
  const [message, setMessage] = useState("{}");
  const [response, setResponse] = useState("");
  const [messageHandle, setMessageHandle] = useState(mockClient.tokenResponse.smart_web_messaging_handle);
  const [targetOrigin, setTargetOrigin] = useState(mockClient.tokenResponse.smart_web_messaging_origin);
  const [client, setClient] = useState(null);
  useEffect(() => {
    setClient(null);
    console.debug("APP: creating a new swm client");
    try {
      new URL(targetOrigin);
    } catch (e) {
      console.warn("not changing client origin:", e);
      return;
    }
    const newClient = new swm.Client(messageHandle, targetOrigin);
    console.debug("APP: enabling new swm client");
    newClient.enable({
      receiveResponse: (r) => {
        setResponse(JSON.stringify(r, null, 2));
      },
      receiveError: console.error
    });
    setClient(newClient);
    prepopulate({...JSON.parse(message), messagingHandle: messageHandle});
    return () => {
      console.log("APP: disabling an expired swm client");
      newClient.disable();
    };
  }, [targetOrigin, messageHandle]);
  useEffect(() => {
    if (document.getElementById("auto-send").checked) {
      sendMessage();
    }
  }, [message]);
  useEffect(() => {
    if (message !== "{}" && !document.getElementById("auto-send").checked) {
      setResponse("Click SEND to send message to EHR...");
    }
  }, [message]);
  function openConfig() {
    document.getElementById("config-panel").showModal();
  }
  function updateMessageHandle(e) {
    setMessageHandle(e.target.value);
  }
  function updateTargetOrigin(e) {
    setTargetOrigin(e.target.value);
  }
  function closeConfig() {
    configSave();
    document.getElementById("config-panel").close();
  }
  function configSave() {
    try {
      const url = new URL(targetOrigin);
      if (url.origin !== targetOrigin) {
        console.warn(`EHR origin is not normalized - saving as '${url.origin}'`);
      }
      mockClient.tokenResponse.smart_web_messaging_origin = url.origin;
      localStorage.setItem("app/ehrOrigin", url.origin);
    } catch (e) {
      console.log("not saving changes to EHR origin!");
      console.error(e);
    }
    mockClient.tokenResponse.smart_web_messaging_handle = messageHandle;
    localStorage.setItem("app/messageHandle", messageHandle);
  }
  function updateMessage(e) {
    setMessage(e.target.value);
  }
  function prepopulate(message2) {
    setMessage(JSON.stringify(message2, null, 2));
  }
  function getHandshakeMessage() {
    return client.createMessage("status.handshake");
  }
  function getUiDoneMessage() {
    return client.createMessage("ui.done");
  }
  function getUiLaunchActivityMessage() {
    return client.createMessage("ui.launchActivity", {
      activityType: "problem-review",
      activityParameters: {
        problemLocation: "Condition/123"
      }
    });
  }
  function getScratchpadCreateMessage() {
    return client.createMessage("scratchpad.create", {
      resource: {
        resourceType: "ServiceRequest",
        status: "draft"
      }
    });
  }
  function getScratchpadReadMessage() {
    return client.createMessage("scratchpad.read");
  }
  function getScratchpadDeleteMessage() {
    const location = "MedicationRequest/456";
    return client.createMessage("scratchpad.delete", {
      location
    });
  }
  function getScratchpadUpdateMessage() {
    const resource = {
      resourceType: "MedicationRequest",
      id: "123",
      status: "draft"
    };
    const location = `${resource.resourceType}/${resource.id}`;
    return client.createMessage("scratchpad.update", {
      location,
      resource
    });
  }
  function sendMessage() {
    try {
      const m = JSON.parse(message);
      swm.checkIsObject(m);
      setResponse("Failed to send message to EHR!");
      client.sendMessage(m);
      setResponse("Awaiting EHR response...");
    } catch (e) {
      setResponse(e.message);
      console.error("failed to send message", e);
    }
  }
  function copyResponseToClipboard() {
    navigator.clipboard.writeText(response);
  }
  var appTitle = "EMBEDDED APP";
  if (window.parent === window.self) {
    appTitle = "No EHR detected for this demo SMART app; SEND is disabled!";
  }
  const messageGetters = {
    "status.handshake": getHandshakeMessage,
    "ui.done": getUiDoneMessage,
    "ui.launchActivity": getUiLaunchActivityMessage,
    "scratchpad.create": getScratchpadCreateMessage,
    "scratchpad.read": getScratchpadReadMessage,
    "scratchpad.update": getScratchpadUpdateMessage,
    "scratchpad.delete": getScratchpadDeleteMessage
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "App"
  }, /* @__PURE__ */ React.createElement("header", {
    className: "App-header"
  }, /* @__PURE__ */ React.createElement("p", null, appTitle), /* @__PURE__ */ React.createElement("button", {
    className: "config-button",
    onClick: openConfig
  }, "configure")), /* @__PURE__ */ React.createElement("main", {
    className: "App-main"
  }, /* @__PURE__ */ React.createElement("dialog", {
    className: "config-panel",
    id: "config-panel"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-header"
  }, /* @__PURE__ */ React.createElement("div", null, "App Settings"), /* @__PURE__ */ React.createElement("button", {
    className: "close-config",
    onClick: closeConfig
  }, "Close")), /* @__PURE__ */ React.createElement("div", {
    className: "config-settings"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-field"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-label"
  }, /* @__PURE__ */ React.createElement("p", null, "Messaging Handle")), /* @__PURE__ */ React.createElement("div", {
    className: "config-text-value"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    value: messageHandle,
    onChange: updateMessageHandle
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "config-field"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "config-label"
  }, /* @__PURE__ */ React.createElement("p", null, "EHR Origin")), /* @__PURE__ */ React.createElement("div", {
    className: "config-text-value"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    value: targetOrigin,
    onChange: updateTargetOrigin
  }))))), /* @__PURE__ */ React.createElement("div", {
    className: "message-panel"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "to-send"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "send-header"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement("i", null, "Editable ")), "Message to send to EHR:"), /* @__PURE__ */ React.createElement("select", {
    id: "template",
    onChange: (e) => {
      const selected = e.target.selectedOptions[0].label;
      prepopulate(messageGetters[selected]());
      e.target.selectedIndex = 0;
    }
  }, /* @__PURE__ */ React.createElement("option", {
    value: ""
  }, "Insert a message..."), /* @__PURE__ */ React.createElement("optgroup", {
    label: "status"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "status.handshake"
  }, "status.handshake")), /* @__PURE__ */ React.createElement("optgroup", {
    label: "ui"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "ui.done"
  }, "ui.done"), /* @__PURE__ */ React.createElement("option", {
    value: "ui.launchActivity"
  }, "ui.launchActivity")), /* @__PURE__ */ React.createElement("optgroup", {
    label: "scratchpad"
  }, /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.create"
  }, "scratchpad.create"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.read"
  }, "scratchpad.read"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.update"
  }, "scratchpad.update"), /* @__PURE__ */ React.createElement("option", {
    value: "scratchpad.delete"
  }, "scratchpad.delete")))), /* @__PURE__ */ React.createElement("textarea", {
    className: "App-message",
    value: message,
    onChange: updateMessage,
    spellCheck: false
  }), /* @__PURE__ */ React.createElement("span", {
    className: "send-controls"
  }, /* @__PURE__ */ React.createElement("label", {
    disabled: window.parent === window.self
  }, /* @__PURE__ */ React.createElement("input", {
    type: "checkbox",
    id: "auto-send",
    disabled: window.parent === window.self
  }), "Auto-SEND"), /* @__PURE__ */ React.createElement("button", {
    className: "send-button",
    onClick: sendMessage,
    disabled: window.parent === window.self
  }, "SEND"))), /* @__PURE__ */ React.createElement("div", {
    className: "from-ehr"
  }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement("i", null, "Read-only ")), "EHR response:"), /* @__PURE__ */ React.createElement("textarea", {
    disabled: true,
    className: "App-message",
    value: response,
    readOnly: true,
    spellCheck: false
  }), /* @__PURE__ */ React.createElement("button", {
    className: "copy-response",
    onClick: copyResponseToClipboard
  }, "Copy to clipboard")))), /* @__PURE__ */ React.createElement("footer", {
    className: "App-footer"
  }, /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    href: "https://tinyurl.com/swm-dd-code"
  }, "https://tinyurl.com/swm-dd-code")));
}
export default App;
